import { render, staticRenderFns } from "./EditorTable.vue?vue&type=template&id=eed3b732&scoped=true"
import script from "./EditorTable.vue?vue&type=script&lang=js"
export * from "./EditorTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed3b732",
  null
  
)

export default component.exports